import { render, staticRenderFns } from "./ServiceSidebar.vue?vue&type=template&id=4fdc40c0&"
import script from "./ServiceSidebar.vue?vue&type=script&lang=js&"
export * from "./ServiceSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports